import React, { useState } from "react";
import "./Products.css";
import GreenCoatedFence from "../assets/images/portfolio/20.png";
import GalvanizedFence from "../assets/images/portfolio/19.png";

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const categories = [
    { id: "all", name: "All Products", icon: "🏪" },
    { id: "rent", name: "Rent", icon: "📱" },
    { id: "sale", name: "Sale", icon: "👕" },
  ];

  const products = [
    {
      id: 1,
      name: "Green Powder-Coated Fence Panels",
      category: "sale",
      price: "",
      image: GreenCoatedFence,
      description:
        "Designed for job sites that demand durability and a polished appearance, our green powder-coated temporary fence panels offer the ideal combination of safety, strength, and visual appeal. The powder coating enhances resistance to corrosion while ensuring the site maintains a professional look.",
      features: [
        "Panel Dimensions: 6 feet high × 9.7 feet wide (1.8m × 2.9m)",
        "30-hour batteryVertical Tube: 25 × 25 × 1 mm",
        "Horizontal Tube: 20 × 20 × 1 mm",
        "Mesh Opening: 2 inches × 6 inches",
        "Wire Diameter: 3 mm",
        "Fence Feet: 800 × 100 × 6 mm",
        "Surface Treatment: Galvanized with green powder coating",
        "Weight: 47 lbs",
      ],
      recommendedUses:
        "Ideal for residential and commercial construction zones, event spaces, and high-visibility areas where aesthetics and safety need to go hand in hand.",
      rating: 4.8,
    },
    {
      id: 2,
      name: "Galvanized Steel Fence Panels",
      category: "sale",
      price: "",
      image: GalvanizedFence,
      description:
        "Our galvanized steel fence panels are built for performance in the toughest conditions. Corrosion-resistant and structurally reinforced, these panels are the preferred choice for long-term use on industrial and infrastructure projects.",
      features: [
        "Panel Dimensions: 6 feet high × 9.7 feet wide (1.8m × 2.9m)",
        "Vertical Tube: 25 × 25 × 1 mm",
        "Horizontal Tube: 20 × 20 × 1 mm",
        "Mesh Opening: 2 inches × 6 inches",
        "Wire Diameter: 3 mm",
        "Fence Feet: 800 × 100 × 6 mm",
        "Surface Treatment: Galvanized with silver paint on welded joints",
        "Weight: 47 lbs",
      ],
      recommendedUses:
        "Suited for high-traffic job sites, infrastructure development, municipal works, and long-term commercial construction projects requiring maximum durability and minimal maintenance.",
      rating: 4.5,
    },
    // {
    //   id: 3,
    //   name: "Smart Home Hub",
    //   category: "electronics",
    //   price: 99.99,
    //   image:
    //     "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop",
    //   description:
    //     "Control your entire smart home ecosystem with voice commands and mobile app integration. Compatible with all major smart devices.",
    //   features: [
    //     "Voice control",
    //     "Mobile app",
    //     "Multi-device support",
    //     "Easy setup",
    //   ],
    //   rating: 4.6,
    // },
    // {
    //   id: 4,
    //   name: "Indoor Plant Collection",
    //   category: "home",
    //   price: 39.99,
    //   image:
    //     "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop",
    //   description:
    //     "Beautiful collection of low-maintenance indoor plants perfect for beginners. Includes care instructions and decorative pots.",
    //   features: [
    //     "Low maintenance",
    //     "Air purifying",
    //     "Decorative pots included",
    //     "Care guide included",
    //   ],
    //   rating: 4.7,
    // },
    // {
    //   id: 5,
    //   name: "Athletic Running Shoes",
    //   category: "sports",
    //   price: 79.99,
    //   image:
    //     "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop",
    //   description:
    //     "High-performance running shoes with advanced cushioning technology and breathable mesh upper. Designed for comfort and durability.",
    //   features: [
    //     "Advanced cushioning",
    //     "Breathable mesh",
    //     "Durable sole",
    //     "Lightweight design",
    //   ],
    //   rating: 4.4,
    // },
    // {
    //   id: 6,
    //   name: "Denim Jacket",
    //   category: "clothing",
    //   price: 59.99,
    //   image:
    //     "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop",
    //   description:
    //     "Classic denim jacket made from premium quality denim. A timeless piece that goes with everything in your wardrobe.",
    //   features: [
    //     "Premium denim",
    //     "Classic fit",
    //     "Multiple pockets",
    //     "Fade resistant",
    //   ],
    //   rating: 4.3,
    // },
  ];

  const filteredProducts =
    selectedCategory === "all"
      ? products
      : products.filter((product) => product.category === selectedCategory);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} className="text-warning">
          ★
        </span>
      );
    }
    if (hasHalfStar) {
      stars.push(
        <span key="half" className="text-warning">
          ☆
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container py-5">
        {/* Hero Section */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h1 className="display-4 fw-bold text-dark mb-3">
              Discover Our Products
            </h1>
            <p className="lead text-muted">
              Browse our curated collection of high-quality products across
              multiple categories.
            </p>
          </div>
        </div>

        {/* Category Filter */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex flex-wrap gap-2 justify-content-center text-green">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`btn ${
                    selectedCategory === category.id
                      ? "btn-primary"
                      : "btn-outline-primary"
                  } rounded-pill`}
                  onClick={() => setSelectedCategory(category.id)}
                >
                  {/* <span className="me-2">{category.icon}</span> */}
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Products Grid */}
        <div className="row g-4">
          {filteredProducts.map((product) => (
            <div key={product.id} className="col-lg-4 col-md-6">
              <div
                className="card h-100 shadow-sm border-0 product-card"
                style={{
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <div className="position-relative overflow-hidden">
                  <img
                    src={product.image}
                    className="card-img-top"
                    alt={product.name}
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                  />
                  <div className="position-absolute top-0 end-0 m-3">
                    <span className="badge bg-success rounded-pill">
                      {renderStars(product.rating)} {product.rating}
                    </span>
                  </div>
                </div>
                <div className="card-body d-flex flex-column">
                  <div className="mb-2">
                    <span className="badge bg-light text-dark rounded-pill small">
                      {
                        categories.find((cat) => cat.id === product.category)
                          ?.name
                      }
                    </span>
                  </div>
                  <h5 className="card-title fw-bold">{product.name}</h5>
                  <p className="card-text text-muted flex-grow-1">
                    {product.description.substring(0, 100)}...
                  </p>
                  <div className="d-flex justify-content-between align-items-center mt-auto">
                    {/* <span className="h4 text-primary fw-bold mb-0">
                      ${product.price}
                    </span> */}
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() => {
                        setSelectedProduct(product);
                        setShowModal(true);
                      }}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="row">
            <div className="col-12 text-center py-5">
              <div className="text-muted">
                <i className="bi bi-search display-1"></i>
                <h3 className="mt-3">No products found</h3>
                <p>Try selecting a different category</p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Product Detail Modal */}
      {showModal && selectedProduct && (
        <div
          className="modal-backdrop-custom"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255)",
            zIndex: 1050,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            style={{ zIndex: 1060, maxWidth: "800px", width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content border-0 shadow" style={{ padding: "1.5rem 0.5rem 1rem 1.5rem" }}>
              <div className="modal-header border-0 pb-3">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div
                className="modal-body pt-0"
                style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <div className="row g-4">
                  <div className="col-md-6">
                    <img
                      src={selectedProduct.image}
                      alt={selectedProduct.name}
                      className="img-fluid rounded shadow-sm"
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <span className="badge bg-primary rounded-pill">
                        {
                          categories.find(
                            (cat) => cat.id === selectedProduct.category
                          )?.name
                        }
                      </span>
                    </div>
                    <h2 className="fw-bold mb-3">{selectedProduct.name}</h2>
                    <div className="mb-3">
                      {renderStars(selectedProduct.rating)}
                      <span className="ms-2 text-muted">
                        ({selectedProduct.rating}/5)
                      </span>
                    </div>
                    <p className="text-muted mb-4">
                      {selectedProduct.description}
                    </p>
                    <p>
                      <span className="fw-bold">Recommended Use:</span>
                      {selectedProduct.recommendedUses}
                    </p>

                    <h5 className="fw-bold mb-3">Features:</h5>
                    <ul className="list-unstyled">
                      {selectedProduct.features.map((feature, index) => (
                        <li key={index} className="mb-2">
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    {/* <div className="d-flex justify-content-between align-items-center mt-4">
                      <span className="h3 text-primary fw-bold">
                        ${selectedProduct.price}
                      </span>
                      <button className="btn btn-primary btn-lg">
                        <i className="bi bi-cart-plus me-2"></i>
                        Add to Cart
                      </button>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;
